import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const GitLabIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M20.6866 13.8822L13.1333 19.1915C12.4433 19.6766 11.5231 19.6766 10.833 19.1915L3.27976 13.8822C3.16308 13.7992 3.07653 13.6826 3.0325 13.5492C2.98846 13.4157 2.9892 13.2722 3.03459 13.1392L4.03161 10.1514L6.02563 4.2154C6.04497 4.16703 6.07576 4.12372 6.11552 4.08893C6.18028 4.03172 6.26481 4 6.35252 4C6.44022 4 6.52475 4.03172 6.58951 4.08893C6.6315 4.12819 6.66244 4.17716 6.67941 4.2312L8.21482 8.78981C8.48886 9.60346 9.25164 10.1514 10.1102 10.1514H13.8549C14.7141 10.1514 15.4772 9.60271 15.7508 8.78828L17.2869 4.2154C17.3063 4.16703 17.3371 4.12372 17.3768 4.08893C17.4416 4.03172 17.5261 4 17.6138 4C17.7015 4 17.7861 4.03172 17.8508 4.08893C17.8928 4.12819 17.9238 4.17716 17.9407 4.2312L19.9347 10.1672L20.9726 13.1392C21.0139 13.2763 21.0084 13.4227 20.9569 13.5565C20.9053 13.6904 20.8105 13.8046 20.6866 13.8822Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const ForwardRef = forwardRef(GitLabIcon)
export { ForwardRef as ReactComponent }
